import { useContext } from "react";
import { NotificationsContext } from "../contexts";

/**
 * Hook to access the shared notifications context (bell count + list).
 *
 * @returns {Object} Notifications context value
 * @returns {Array} notifications - Short list of recent notifications
 * @returns {number} unreadCount - Count of unread notifications
 * @returns {Function} reloadNotifications - Call after marking/deleting a
 * notification anywhere in the app so the bell updates immediately.
 *
 * @example
 * const { unreadCount, reloadNotifications } = useNotifications();
 *
 * await notificationController.updateNotification(id, { viewed: true });
 * reloadNotifications();
 */
export const useNotifications = () => useContext(NotificationsContext);
